import Log from "../Log/Log";

const REDIRECT_PLACE_RE = /^[a-zA-Z0-9][a-zA-Z0-9/_-]*$/;
const REDIRECT_PLACE_FALLBACK = "finance/payment";

export function buildAuthRedirect(
  authUrl: string,
  pathname: string = window.location.pathname,
): string {
  let p = pathname.replace(/^\/+/, "");
  if (p.indexOf("app/") === 0) {
    p = p.slice(4);
  }
  if (!REDIRECT_PLACE_RE.test(p)) {
    Log.warn(
      `buildAuthRedirect: pathname produced non-compliant redirectPlace; falling back to "${REDIRECT_PLACE_FALLBACK}"`,
      { pathname, attempted: p },
    );
    p = REDIRECT_PLACE_FALLBACK;
  }
  return `${authUrl}?redirectPlace=${encodeURIComponent(p)}`;
}
